import React from 'react';
import { CaseStudyCard } from './CaseStudyCard';
import { caseStudies } from '../../data/caseStudies';
export function ResultsCaseStudies() {
  return <section className="w-full bg-brand-light-gray py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-248" data-mp="sw8zpi7qklt4">
      <div className="max-w-4xl mx-auto" data-id="element-249" data-mp="ost6ywysf5lp">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-10" data-id="element-250" data-mp="jtpzl5vc4nak">
          Case studies
        </h2>
        <div className="space-y-10" data-id="element-251" data-mp="1gjyxclophoxs">
          {caseStudies.map(study => <CaseStudyCard key={study.id} study={study} data-id="element-252" data-mp="1cidqbgyus4vi" />)}
        </div>
      </div>
    </section>;
}